export const themeCSSPrefix = 'app'
